// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"69":"participate","94":"collaborators","130":"teaching","286":"lab_news","353":"contact","516":"team","678":"publications","702":"funding"}[chunkId] + "." + {"69":"08650b6e","94":"c6886c2b","130":"1b230ba1","286":"6653c0a1","353":"2d86ec11","516":"4c2f5891","678":"eee35e8f","702":"a693161d"}[chunkId] + ".js";
};